// Listado de devoluciones: orquesta desktop/móvil; lógica en useRefundIndex.
import React from 'react'
import Box from '@mui/material/Box'

import LoadingScreen from '../../components/LoadingScreen'
import { RefundIndexMobileFilters, RefundMobilePagination } from '../mobile'
import useRefundIndex from './hooks/useRefundIndex'
import RefundIndexDesktopFilters from './RefundIndexDesktopFilters'
import RefundIndexDesktopTable from './RefundIndexDesktopTable'
import RefundIndexDesktopPagination from './RefundIndexDesktopPagination'
import RefundIndexMobileList from './RefundIndexMobileList'

const RefundIndexView = () => {
  const {
    isFetching,
    isMobileList,
    data,
    showNcrColumn,
    pagination,
    handlePagination,
    searchInput,
    filterConfigs,
    appliedFilterSelections,
    appliedFilterGroupCount,
    appliedFilterChips,
    selectedDates,
    isAnyFilterSelected,
    handleDesktopFilterChange,
    handleDateFilter,
    handleFilterSearchChange,
    handleFilterLoadMore,
    resetReactFilters,
    handleSearch,
    handleEnterSearch,
    clearSearchInput,
    handleMuiPageChange,
    handleMuiRowsPerPageChange,
    isMobileFiltersOpen,
    draftFilterSelections,
    draftDateRange,
    expandedRefundUuid,
    handleOpenMobileFilters,
    handleCloseMobileFilters,
    handleDraftSelectChange,
    handleDraftDateChange,
    clearDraftDateRange,
    clearAllMobileFilters,
    applyMobileFilters,
    toggleRefundCardExpand
  } = useRefundIndex()

  if (isFetching) {
    return <LoadingScreen text="Cargando..." />
  }

  return (
    <>
      <div className="index-header detailed-container">
        <h2 className="mb-20">Devoluciones</h2>
      </div>

      <div className="index-table">
        <div className="show-area">
          {isMobileList ? (
            <RefundIndexMobileFilters
              query={searchInput}
              handleSearchChange={handleSearch}
              handleSearchKeyDown={handleEnterSearch}
              clearSearch={clearSearchInput}
              openFilters={handleOpenMobileFilters}
              appliedFilterGroupCount={appliedFilterGroupCount}
              appliedFilterChips={appliedFilterChips}
              isOpen={isMobileFiltersOpen}
              closeFilters={handleCloseMobileFilters}
              mobileFilterConfigs={filterConfigs}
              draftFilterSelections={draftFilterSelections}
              handleDraftSelectChange={handleDraftSelectChange}
              anyFilterEmpty={false}
              draftDateRange={draftDateRange}
              handleDraftDateChange={handleDraftDateChange}
              clearDraftDateRange={clearDraftDateRange}
              clearAllFilters={clearAllMobileFilters}
              applyFilters={applyMobileFilters}
              onFilterSearchChange={handleFilterSearchChange}
              onFilterLoadMore={handleFilterLoadMore}
            />
          ) : (
            <RefundIndexDesktopFilters
              filterConfigs={filterConfigs}
              appliedFilterSelections={appliedFilterSelections}
              selectedDates={selectedDates}
              isAnyFilterSelected={isAnyFilterSelected}
              searchInput={searchInput}
              onFilterChange={handleDesktopFilterChange}
              onDateChange={handleDateFilter}
              onFilterSearchChange={handleFilterSearchChange}
              onFilterLoadMore={handleFilterLoadMore}
              onResetFilters={resetReactFilters}
              onSearchChange={handleSearch}
              onSearchEnter={handleEnterSearch}
              onSearchClear={clearSearchInput}
            />
          )}

          {isMobileList ? (
            <RefundIndexMobileList
              data={data}
              expandedRefundUuid={expandedRefundUuid}
              onToggleExpand={toggleRefundCardExpand}
            />
          ) : (
            <RefundIndexDesktopTable data={data} showNcrColumn={showNcrColumn} />
          )}

          {isMobileList && pagination.total_pages > 1 ? (
            <Box sx={{ mt: 1 }}>
              <RefundMobilePagination pagination={pagination} handlePagination={handlePagination} />
            </Box>
          ) : null}

          {!isMobileList && pagination.total_count > 0 ? (
            <RefundIndexDesktopPagination
              pagination={pagination}
              onPageChange={handleMuiPageChange}
              onRowsPerPageChange={handleMuiRowsPerPageChange}
            />
          ) : null}
        </div>
      </div>
    </>
  )
}

export default RefundIndexView
